import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppStateContext } from "src/auth/AppStateContext";
import { UseAuth } from "src/auth/AuthContext";
import APIService from "src/services/Api";
import { CashierUser } from "src/types";


type ParamsGetCashierFather = {
  setCashier(cashier:CashierUser): void
}
const GetCashierFather: React.FC<ParamsGetCashierFather> = ({setCashier}) => {

  const {setCashierFather } = useAppStateContext()
  const { user } = UseAuth()
  const navigate = useNavigate();

  const fetch = async() => {
    if(user?.role === 'user'){
      const res = await APIService.userFindMyCashier({ userId: (user?.id || '') });
      const cashier = res?.data?.data?.cashier;
      if(cashier && cashier.id && ( cashier.id.length > 0)){
        setCashier(cashier)
        setCashierFather(cashier)
      }else{
        navigate('/elegir-cajero')
      }
    }
  }
  useEffect(() => {
    fetch()
  }, [])
  
  return <></>
};


export default GetCashierFather